import React, { useState } from "react";
import { useEffect } from "react";

const overlayStyle = {
	position: "fixed",
	top: 0,
	left: 0,
	width: "100vw",
	height: "100vh",
	background: "rgba(255,255,255,0.90)",
	zIndex: 9999,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

const dialogStyle = {
	background: "#fff",
	padding: "2rem 3rem",
	textAlign: "center",
	maxWidth: "90vw",
	minWidth: "320px",
	border: "1px solid #333",
};

const buttonStyle = {
	marginTop: "2rem",
	padding: "7px 15px",
	fontSize: "1.1rem",
	border: "none",
	background: "#222",
	color: "#fff",
	cursor: "pointer",
	transition: "background 0.2s",
};

export default function AdultWarning() {
	const [open, setOpen] = useState(true);

	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, []);

	if (!open) return null;

	return (
		<div style={overlayStyle}>
			<div style={dialogStyle}>
				<h1 className="text-lg sm:text-xl  mb-[18px]  font-bold"> Adult contet ahead</h1>
				<p className="text-base sm:text-base mt-1">
					Things around here might get on the kinky side. 
				</p>
				<p className="text-base sm:text-base">  Are you 18 years or older? </p>
				<button
					style={buttonStyle}
					onClick={() => {
						document.body.style.overflow = "";
						document.cookie = "isAdult=true; path=/; max-age=31536000";
						setOpen(false);
					}}
				>
					I'm an adult
				</button>
			</div>
		</div>
	);
}

